export let useClassicPaths = false;

export function setUseClassicPaths(value: boolean) {
  useClassicPaths = value;
}
